// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1":"e99b9d7d","532":"2b12f694"}[chunkId] + ".chunk.css");